import classNames from 'classnames'
import { TProductParams } from 'feature/appeals/type'
import { useState } from 'react'
import { LoaderInCentalPosition } from 'widget'

import style from './ProductInformationParam.module.scss'

// параметр заказа
export function ProductInformationParam({
  settings,
}: {
  settings: TProductParams
}) {
  const { name, parameterValue, iconUrl } = settings
  const [isImageError, setImageError] = useState<boolean>(false)
  const [isImageLoading, setImageLoading] = useState<boolean>(true)

  const onErrorImg = () => {
    setImageError(true)
    setImageLoading(false)
  }

  const onLoadImg = () => {
    setImageLoading(false)
  }

  if (parameterValue?.value === '' || parameterValue?.value === null) {
    return <></>
  }

  return (
    <div className={style.settings}>
      <div
        className={classNames(
          style.imgWrapper,
          !isImageLoading && style.productImgVisible,
        )}
      >
        {isImageLoading && <LoaderInCentalPosition props={{ size: 24 }} />}
        <img
          src={iconUrl}
          alt={name}
          className={classNames(
            style.productImg,
            isImageError && style.productImgError,
          )}
          onError={onErrorImg}
          onLoad={onLoadImg}
          loading='lazy'
        />
      </div>

      <div className={style.parameter}>
        <span className='default-text'>{name}</span>
        {parameterValue?.displayValue && (
          <span className={classNames('default-text', style.parameterValue)}>
            {`: ${parameterValue.displayValue}`}
          </span>
        )}
      </div>
    </div>
  )
}
